<template>
  <div class="bonus_sect">
    <h3>{{ $_translations.value.page_store_section_bonus_phase_title }}</h3>

    <p>
      {{ $_translations.value.page_store_section_bonus_phase_description_pt1 }}
      {{ amountText }}
      {{ $_translations.value.page_store_section_bonus_phase_description_pt3 }}
    </p>

    <BaseCountdownTimer
      :end-date="endDate"
      el-class="bonus_timer"
      timer-format="hh:mm:ss"
      @time:expired="$emit('bonusPhase:expired')"
    />
  </div>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import BaseCountdownTimer from '@/components/timer/BaseCountdownTimer.vue';

defineEmits(['bonusPhase:expired']);

const props = defineProps({
  endDate: {
    type: [Date, String, Number],
    default: 0,
  },
  amount: {
    type: Number,
    default: 0,
  },
});

const { proxy } = getCurrentInstance();

const amountText = computed(() => {
  switch (props.amount) {
    case 2:
    case 3:
    case 4:
      return proxy.$_translate(`page_store_section_bonus_phase_description_pt2_x${ props.amount }`);
    default:
      return `x${ props.amount }`;
  }
});
</script>
